import React, { createContext, useState, ReactNode } from "react";

interface UserContextConfig {
  isLoggedIn: boolean;
  handleLogin: (loggedIn: boolean) => void;
}

export const UserContext = createContext<UserContextConfig>({
  isLoggedIn: false,
  handleLogin: () => {
    return;
  },
});

export const UserContextProvider = ({ children }: { children: ReactNode }) => {
  const [isLoggedIn, setLoggedIn] = useState<boolean>(false);

  const handleLogin = (loggedIn: boolean) => {
    setLoggedIn(loggedIn);
  };

  return (
    <UserContext.Provider value={{ isLoggedIn, handleLogin }}>
      {children}
    </UserContext.Provider>
  );
};
